import _moment from 'moment-timezone' // includes moment

export const urlFormat = 'Y-MM-DD'
export const displayFormat = 'ddd, MMM Do'

// FYI: Saturdays were disabled in #44 (plus hotfixes) and re-enabled in #50.
// export const disallowedISOWeekdays = [6, 7] // 6 = Saturday and 7 = Sunday
// export const INVALID_DAY_OF_WEEK_ERROR = 'Cannot place an order for Saturday or Sunday.'
export const disallowedISOWeekdays = [7] // 7 = Sunday
export const INVALID_DAY_OF_WEEK_ERROR = 'Cannot place an order for Sunday.'

const BACKWARD = 'BACKWARD'
const FORWARD = 'FORWARD'
const YESTERDAY = 'yesterday'
const TODAY = 'today'
const TOMORROW = 'tomorrow'

// WARNING: Do not use this with a calculated date as doing `moment(date)` will already "update" this to the next valid date.
// Use `!disallowedISOWeekdays.includes(dayOfWeek)` instead.
export const isAllowedDate = (date, debug = false) => {
  const dayOfWeek = date.isoWeekday()
  return !disallowedISOWeekdays.includes(dayOfWeek)
}

const getFirstValidDayOfWeek = (date, direction = FORWARD) => {
  if (!isAllowedDate(date)) {
    let incrementDay = 1
    if (direction === BACKWARD) incrementDay = -1

    // If this is a disallowed date, we "add" either +1 or -1 day
    const newDate = date.clone().add(incrementDay, 'day')

    // Now re-run it!  It might have another disallowed date.
    return getFirstValidDayOfWeek(newDate, direction)
  }

  return date
}

export const moment = (parse = TODAY, options = {}) => {
  options = Object.assign({}, {
    throwError: true,
    required: true,
    // timezone: undefined,
    castAsTimezone: false
  }, options)

  if (!parse && options.required) {
    throw new Error('A date must be provided at initalization unless overriden.')
  }

  let switchCompare = parse

  // only set switchCompare to lowerCase, not parse, so we don't lowerCase date strings, eg. ISO timezones..
  if (typeof parse.toLowerCase === 'function') {
    switchCompare = parse.toLowerCase()
  }

  const now = options.castAsTimezone
    ? _moment.tz(undefined, options.timezone)
    : _moment(undefined)

  let date
  let direction = FORWARD
  if (!parse) {
    date = now.clone()
  } else {
    switch (switchCompare) {
      case YESTERDAY:
        date = now.clone().subtract(1, 'days')
        direction = BACKWARD
        break
      case TODAY:
        date = now.clone()
        break
      case TOMORROW:
        date = now.clone().add(1, 'days')
        break
      default:
        date = options.castAsTimezone
          ? _moment.tz(parse, options.timezone)
          : _moment(parse)
    }
  }

  date = getFirstValidDayOfWeek(date, direction)

  if (date.isValid()) return date

  if (options.throwError) {
    throw new Error(`${parse} is not a valid date.`)
  }

  return false
}

export default moment



// WEBPACK FOOTER //
// ./both/helpers/moment.js